import { FC } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectSuburbanAreaDailyRentFilter } from 'shared/selectors/advancedFilters';

export const SuburbanAreaDailyRentContainer: FC = () => {
  const { label, valueMax, valueMin, min, max } = useSelector(selectSuburbanAreaDailyRentFilter);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setTotalAreaMin', arguments: [value] });
  });

  const handleMaxChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setTotalAreaMax', arguments: [value] });
  });

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilter width={100} postfix={'м\u00b2'}>
        <RangeInput
          min={min}
          max={max}
          valueMin={valueMin}
          valueMax={valueMax}
          onChangeMin={handleMinChange}
          onChangeMax={handleMaxChange}
        />
      </InlineFilter>
    </AdvancedFilterRow>
  );
};
